import { alpha, styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import ButtonBase from '@mui/material/ButtonBase';

export const Message = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  color: theme.palette.brand.darkGreen
}));

export const MethodCard = styled(ButtonBase)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'stretch',
  width: '100%',
  padding: '12px 16px',
  textAlign: 'left',
  color: theme.palette.neutrals.lead,
  backgroundColor: theme.palette.neutrals.beige2,
  border: `1px solid ${theme.palette.neutrals.beige4}`,
  borderRadius: '8px',
  boxShadow: `0px 4px 8px 0px ${alpha(theme.palette.common.black, 0.08)}`,
  '&:hover, &.Mui-focusVisible': {
    backgroundColor: theme.palette.neutrals.beige1
  },
  '&.Mui-disabled': {
    opacity: 0.6
  }
}));

export const CardHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
  width: '100%'
});

export const IconShape = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: '48px',
  height: '48px',
  borderRadius: '100px',
  backgroundColor: theme.palette.neutrals.beige3
}));

export const MethodTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.body1B,
  fontFamily: theme.typography.body2B.fontFamily,
  lineHeight: 1.36,
  flex: 1,
  color: theme.palette.neutrals.lead
}));

export const MethodValue = styled(Typography)(({ theme }) => ({
  ...theme.typography.subtitle2,
  paddingLeft: '64px',
  color: theme.palette.neutrals.lead,
  wordBreak: 'break-word'
}));

export const ErrorText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2B,
  lineHeight: 1.2,
  color: theme.palette.error.main
}));

export const ContinueButton = styled(Button)(({ theme }) => ({
  ...theme.typography.body7B,
  paddingTop: 0
}));
